<script>
import { page } from '@/api/business/containerTransportOrder'

export default {
  name: 'LadingCargoDetailSelect',
  components: {},
  props: {
    value: {
      type: [Number, String]
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ladingOrderId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      show: false,
      selectedRowId: this.value,
      selectedRow: {},
      loading: false,
      data: []
    };
  },
  computed: {
    showLabel() {
      if (this.selectedRow && Object.keys(this.selectedRow).length) {
        return `第${this.selectedRow.sortNo}程 · ${this.selectedRow.transportCompanyName}`
      }
      return null
    }
  },
  watch: {
    value() {
      this.selectedRowId = this.value
    }
  },
  mounted() {
    
  },
  methods: {
    onShow() {
      if (this.disabled) {
        return
      }
      this.show = true
      this.onQuery()
    },
    onQuery() {
      this.loading = true
      const params = {
        ladingOrderId: this.ladingOrderId,
        size: 999
      }
      page(params).then(res => {
        this.data = res.data.records || []
      }).finally(() => {
        this.loading = false
      })
      // setTimeout(() => {
      //   this.data = Array(5).fill({
      //     orderCargoDetailId: null,
      //     cargoNo: 'HW202401001',
      //     cargoTypeName: '集装箱',
      //     cargoSpecName: '20GP',
      //     cargoAttrUniNo: 'CBHU202401001',
      //     cargoAttrSealNo: 'FQ202401001',
      //     cargoAttrLoadBoxDate: '2024-01-01',
      //     cargoAttrName: '汽车零部件'
      //   }).map((item, index) => ({ ...item, orderCargoDetailId: index + 1 }))
      //   this.loading = false
      // }, 300)
    },
    handleRadioChange(row) {
      this.selectedRowId = row.id;
      this.selectedRow = row
      this.show = false
      this.$emit('input', this.selectedRowId)
      this.$emit('change', this.selectedRow)
    },
    onClear() {
      this.selectedRowId = null
      this.selectedRow = {}
      this.$emit('input', null)
      this.$emit('change', {})
    }
  }
}
</script>

<template>
  <div>
    <!-- 触发器 -->
    <div class="reference-wrapper" @click="onShow">
      <el-input
        v-model="showLabel"
        :placeholder="placeholder"
        readonly
        :disabled="disabled"
      >
        <template #suffix>
          <div class="reference-wrapper__clearable" v-show="clearable && value && !disabled" @click.stop="onClear">
            <i class="el-icon-circle-close cursor" />
          </div>
        </template>
      </el-input>
    </div>
    <el-dialog
      title="选择货物"
      :visible.sync="show"
      width="800px"
      append-to-body
    >
      <eu-loading v-if="loading" style="height: 300px;"></eu-loading>
      <el-table
        v-else
        :data="data"
        style="width: 100%"
        highlight-current-row
        @current-change="handleRadioChange"
      >
        <el-table-column prop="orderCargoDetailId" width="40">
          <template slot-scope="{ row }">
            <el-radio v-model="selectedRowId" :label="row.id" @change.native="handleRadioChange(row)">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="sortNo" label="第几程"></el-table-column>
        <el-table-column prop="transportCompanyName" label="运输公司"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.reference-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 2px;
  line-height: 32px;
  box-sizing: border-box;
  height: 32px;
}
.reference-wrapper__clearable {
  position: absolute;
  right: 0.5em;
  z-index: 1;
}
</style>